import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomEvents = lazy(() =>
  import("@scenes/CustomEvents").then((module) => ({
    default: module.CustomEvents,
  }))
);

export const customEventsReportNRO: NavigationRoutingObject = {
  Component: CustomEvents,
  componentFeatureFlippers: ["custom_events_report_nro_component"],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("custom-events-report-sidebar-pill-menu-option", "Custom Events Report"),
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("custom-events", "Custom Events")],
      description: t("previously-custom-events", 'Previously "Custom Events"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/custom_events/:appGroupId",
};
